<template>
  <div>
      <a-input type="hidden" name="username" :value="username"/>
      <a-input @change="handleInputChanged" type="text" :value="username"/>
  </div>
</template>

<script>
export default {
  name: 'CustomerUsernameEditComponent',
  props: {
    initialUsername: {
      type: String,
      required: false,
      default: null
    },
  },
  data() {
    return {
      username: null,
    }
  },
  mounted() {
    this.username = this.initialUsername
  },
  methods: {
    handleInputChanged(e){
      this.username = e.target.value
    }
  }
}
</script>